import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AdminAuthProvider } from "@/lib/auth";
import ParentGate from "@/components/ParentGate";
import HomePage from "@/pages/Home";
import TripLandingPage from "@/pages/Trip";
import RegisterFlow from "@/pages/Register";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AdminAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ParentGate><HomePage /></ParentGate>} />
            <Route path="/trip/:tripKey" element={<ParentGate><TripLandingPage /></ParentGate>} />
            <Route path="/trip/:tripKey/register" element={<ParentGate><RegisterFlow /></ParentGate>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AdminAuthProvider>
    </div>
  );
}

export default App;
